var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-card-title',{staticClass:"headline"},[_vm._v("Olá, "),_c('b',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.usuarioLogado.nome))])]),_c('v-card-text',{staticClass:"mt-2"},[_c('alerta-pedidos-sync'),_c('atalhos-iniciais')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }